import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from '@getro/rombo';
import { Text, Flex } from 'rebass/styled-components';

export const ModalRevokeApiKey = ({ onClose, onConfirm, isLoading = false }) => (
  <Modal
    title="Delete API key?"
    isOpen
    onCancel={onClose}
    actions={
      <Flex justifyContent="flex-end" sx={{ gap: '16px' }}>
        <Button onClick={onConfirm} variant="danger" loading={isLoading}>
          Delete API key
        </Button>
      </Flex>
    }
  >
    <Text fontSize="14px">
      Any integration using this API key will immediately stop working. This action cannot be undone.
    </Text>
  </Modal>
);

ModalRevokeApiKey.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

ModalRevokeApiKey.defaultProps = {
  isLoading: false,
};
